import React from 'react';
import { useEffect } from 'react';
import { connect } from 'react-redux';

import { Button, Notification, Paper } from 'redpoints-front-components/index';

import {
  facilitatorValidationDelay,
  facilitatorValidationDone,
  facilitatorValidationFetchNext,
} from '../../../actions/facilitatorValidationActions';
import {
  getFacilitatorValidationActionsAreLoading,
  getFacilitatorValidationContentLinkUrls,
  getFacilitatorValidationDelayIsSuccess,
  getFacilitatorValidationDoneIsSuccess,
  getFacilitatorValidationDoneIsTaskFailed,
  getFacilitatorValidationSelectedDomainId,
  getFacilitatorValidationSelectedFilterByCustomer,
} from '../../../reducers/tasks/facilitatorValidation';
import { translate } from '../../../helpers/languageHelper';

const FacilitatorValidationContentActions = ({
  areLoadingActions,
  contentLinkUrls,
  domainId,
  facilitatorValidationDelay,
  facilitatorValidationDone,
  facilitatorValidationFetchNext,
  filterByCustomer,
  isDelaySuccess,
  isDoneSuccess,
  isEditing,
  isTaskFailed,
  linkInfo,
  setIsEditing,
}) => {
  const { linkId, customerId } = linkInfo;

  const customerIdToFetch = filterByCustomer ? customerId : undefined;

  useEffect(() => {
    if (!contentLinkUrls && !isEditing) {
      setIsEditing(true);
    }
  }, [contentLinkUrls, isEditing, setIsEditing]);

  useEffect(() => {
    if (isDelaySuccess) {
      facilitatorValidationFetchNext({
        domainId,
        customerId: customerIdToFetch,
      });
      setIsEditing(true);
    }
  }, [
    customerIdToFetch,
    domainId,
    facilitatorValidationFetchNext,
    isDelaySuccess,
    setIsEditing,
  ]);

  useEffect(() => {
    if (isDoneSuccess) {
      facilitatorValidationFetchNext({
        domainId,
        customerId: customerIdToFetch,
      });
      setIsEditing(true);
    }
  }, [
    customerIdToFetch,
    domainId,
    facilitatorValidationFetchNext,
    isDoneSuccess,
    setIsEditing,
  ]);

  useEffect(() => {
    if (isTaskFailed) {
      Notification.error({
        message: translate('error.something_wrong'),
      });
    }
  }, [isTaskFailed]);

  const handleDone = () => {
    facilitatorValidationDone({
      contentLinks: contentLinkUrls,
      linkTaskRequest: linkInfo,
    });
    setIsEditing(false);
  };

  const handleDelay = () => {
    facilitatorValidationDelay({ customerId, linkId });
  };

  const isLoadingAction = !isEditing || areLoadingActions;

  return (
    <Paper className="facilitator-validation-content-actions">
      <Button
        className="ant-btn-sm"
        disabled={contentLinkUrls || isLoadingAction}
        onClick={handleDelay}
        type="warning"
      >
        {translate('actions.delay')}
      </Button>
      <Button
        className="ant-btn-sm"
        disabled={isLoadingAction}
        onClick={handleDone}
        type="primary"
      >
        {translate('actions.done')}
      </Button>
    </Paper>
  );
};

const mapStateToProps = state => ({
  areLoadingActions: getFacilitatorValidationActionsAreLoading(state),
  contentLinkUrls: getFacilitatorValidationContentLinkUrls(state),
  domainId: getFacilitatorValidationSelectedDomainId(state),
  filterByCustomer: getFacilitatorValidationSelectedFilterByCustomer(state),
  isDelaySuccess: getFacilitatorValidationDelayIsSuccess(state),
  isDoneSuccess: getFacilitatorValidationDoneIsSuccess(state),
  isTaskFailed: getFacilitatorValidationDoneIsTaskFailed(state),
});

export default connect(mapStateToProps, {
  facilitatorValidationDelay,
  facilitatorValidationDone,
  facilitatorValidationFetchNext,
})(FacilitatorValidationContentActions);
